import { derived, readable, writable } from "svelte/store";

export let settings = writable(null);

export let loggedUser = writable(null);

export const isAdmin = derived(loggedUser, ($loggedUser) => {
  return $loggedUser?.role === 'ADMIN';
});

export const isGroupManager = derived(loggedUser, ($loggedUser) => {
  return $loggedUser?.role === 'GROUP_MANAGER';
});

export const isRootManager = derived(loggedUser, ($loggedUser) => {
  return !!$loggedUser?.isRootManager;
});

export const queryParams = readable(new URLSearchParams(window.location.search), (set) => {
  const update = () => set(new URLSearchParams(window.location.search));
  window.addEventListener('popstate', update);
  return () => window.removeEventListener('popstate', update);
});